// ПИСАТЬ ТОЛЬКО С ДВОЙНЫМИ СКОБКМИ!
export const ru = {
    "app.toastNetworkError": "Ошибка соединения",
    "app.screenNotFound": "Страница не найдена",
    "screen.order.dragTooltipStart": "Перетащите файлы или кликните для выбора. Можно добавлять файлы в формате PDF, PNG или JPEG",
    "screen.order.dragTooltipInProgress": "Отпустите файл",
    "screen.order.wrongFileType": "Формат файла должен быть {type}",
    "screen.order.wrongFileSize": "Размер файла больше {size}",
    "screen.order.wrongFilesCount": "Максимальное количество загружаемых файлов {count}",

    "screen.order.title": "Заказ № {orderNumber}",
    "screen.order.uploadSuccessTitle": "Успешная операция",
    "screen.order.uploadSuccessMessage": "Документы успешно загружены. Ожидайте проверки.",
    "screen.order.uploadSuccessMessage.foreignPassport": "Получены дополнительные документы для таможенного оформления.",
    "screen.order.orderDocumentNotNeed": "Предоставление документов не требуется.",
    "screen.order.uploadButton": "Загрузить",

    "screen.order.orderSuccessTitle": "Успешная операция",
    "screen.order.orderErrorTitle": "Ошибка",
    "screen.order.orderDeadlineExpiredMessage": "Истек срок предоставления документов.",
    "screen.order.orderHaveNotBeenVerifiedMessage": "Ваши документы не прошли проверку. Повторите загрузку.",

    "screen.order.previewModal.accept": "Подтвердить",
    "screen.order.previewModal.cancel": "Отменить",
}